module.exports = __webpack_public_path__ + "static/SEAcert-72ad2ddcdc70e1885a7a4b1b8fc2c55b.jpg";